import Sections from '~/constants/sections';
import { useCurrentSection } from '../../DesktopPageNavigation/hooks';

const sectionLabels = {
  [Sections.KeyFeatures]: 'Key Features',
  [Sections.VehicleDetails]: 'Vehicle Details',
  [Sections.PriceDetails]: 'Price Details',
  [Sections.OwnerReviews]: 'Owner Reviews',
  [Sections.Inspection150Point]: 'Inspection & History',
  [Sections.BuyWithConfidence]: 'Money Back Guarantee'
};

const topOffset = 137; // It's maaaaagiiiic....

export default function useCurrentDropDownLabel() {
  const currentSection = useCurrentSection(topOffset);

  return sectionLabels[currentSection] ?? 'Jump to';
}
